import { Injectable } from '@angular/core';
import { tokenNotExpired } from 'angular2-jwt';

import { Http , Response} from '@angular/http';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { Utils } from './../shared/utils';
import 'rxjs/add/operator/toPromise';

import { environment } from "../../environments/environment";
import { Usuario } from './../usuario/usuario';

@Injectable()
export class AuthAndACLService {

  //service = encodeURIComponent( API_HOSTNAME+'/jwt/login/?path='+href);
  private authUrl = '/autenticarAlunoExterno';

  constructor(
    private http: Http,
    private _flashMessagesService: FlashMessagesService,
    private utils: Utils
  ) { }

  // This method will display the lock widget
  login(): void {
    let href = window.location.href;
    let origin = window.location.origin;
    console.log(origin);
    href = origin + "/meus_documentos";
    let service = encodeURIComponent( environment.url_api + '/login');

    //window.location.href = environment.url_cas + '/login?service='+service;

    window.location.href = environment.url_api + '/login?path=' + href
    
    //window.location.href = environment.url_api + '/login'

  }

  logado(): boolean{
      return tokenNotExpired();
  }

  dadosUsuario(path:string ,token:string ): void{
    localStorage.setItem('token', token);
    window.location.href = path;
  }

  logout(): void{
    localStorage.clear();
    let service = environment.url_api+'/logout/?path='+ environment.url_logout;
    window.location.href = service;
  }

  canAccess(accessRoles:string[]): boolean{
    let usuario:Usuario = new Usuario();
    let perfis:string[] = usuario.perfis;
    let public_route:any = (accessRoles === undefined);

    if ( public_route ){
      return true
    }

    if( usuario === undefined && usuario.perfis === undefined){
      return false;
    }

    for (var key in perfis){
      if(accessRoles.indexOf(perfis[key]) > -1){
        return true
      }
    }

    return false;
  }

  autenticaAlunoExterno(crediential: any): Promise<Response>{
    return this.http
               .post(this.authUrl, this.utils.buildFormData(crediential))
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  private handleSuccess(resp: any): Promise<any> {
    this.utils.flashMessage(resp.msg, 'success');
    //this._flashMessagesService.show(resp.msg, { cssClass: 'card alert-success', timeout: 5000 });
    return resp.dados;
  }

  private handleError(error: any): Promise<any> {
     switch (error.status) {
      case 500:
        this.utils.flashMessage('Ocorreu error no servidor, entre em contato com o administrador.', 'danger');
        //this._flashMessagesService.show("Ocorreu error no servidor, entre em contato com o administrador.", { cssClass: 'card alert-danger', timeout: 5000 });
        break;
      case 403:
        this.utils.flashMessage(error.json().msg, 'warning');
        //this._flashMessagesService.show(error.json().msg, { cssClass: 'card alert-warning', timeout: 5000 });
        break;
      default:
      this.utils.flashMessage("Ocorreu um error, tente novamente mais tarde.", 'danger');
        //this._flashMessagesService.show("Ocorreu um error, tente novamente mais tarde.", { cssClass: 'card alert-danger', timeout: 5000 });
    }
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/auth_and_acl/authAndACL.service.ts